import React from 'react';
import { Link } from "react-router-dom";
import '../../assets/scss/unauthorized.scss';

const Unauthorized = () => {

	return (
		<>
			<div className="wrapper-1">
				<div className="wrapper-2">
					<h1><code>Access Denied!</code></h1>
					<hr style={{ margin: "auto", width: "50%" }} />
					<h3 className="mt-2">You dont have permission to view this page.</h3>
					<h3>🚫🚫🚫🚫</h3>
					<Link to='/dashboard' style={{ textDecoration: "none", color: "black" }}><button className="btn btn-secondary mt-2">Back to Site</button></Link>
				</div>
			</div>
		</>
	);
};

export default Unauthorized;